import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { usePreferredReducedMotion } from '@vueuse/core';

export const useUiStore = defineStore('ui', () => {
  const preferredMotion = usePreferredReducedMotion();
  const currentlyLoadingElements = ref(new Set<unknown>());

  const prefersReducedMotion = computed(() => preferredMotion.value === 'reduce');
  const transitionsEnabled = computed(() => prefersReducedMotion.value === false);
  const isCurrentlyLoadingOneOrMoreElements = computed(() => currentlyLoadingElements.value.size > 0);

  function addLoadingElement (element: unknown) {
    currentlyLoadingElements.value.add(element);
  }

  function removeLoadingElement (element: unknown) {
    currentlyLoadingElements.value.delete(element);
  }

  return {
    currentlyLoadingElements,
    prefersReducedMotion,
    transitionsEnabled,
    isCurrentlyLoadingOneOrMoreElements,
    addLoadingElement,
    removeLoadingElement,
  };
});
